import { render } from "./dark-mode-toggle.vue?vue&type=template&id=bee175f6"
import script from "./dark-mode-toggle.vue?vue&type=script&lang=js"
export * from "./dark-mode-toggle.vue?vue&type=script&lang=js"

import "./dark-mode-toggle.vue?vue&type=style&index=0&id=bee175f6&lang=scss"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__